import { useState, useEffect, useRef } from "react";

const useTabFilteredData = (data, activeTab, config = {}) => {
    const [result, setResult] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const workerRef = useRef(null);

    useEffect(() => {
        workerRef.current = new Worker(new URL("../workers/filtering.worker.js", import.meta.url), { type: "module" });
        workerRef.current.onmessage = (e) => {
            setResult(e.data.result);
            setIsLoading(false);
        };
        return () => {
            workerRef.current.terminate();
        };
    }, []);

    useEffect(() => {
        setIsLoading(true);
        workerRef.current.postMessage({
            type: "tab",
            data,
            activeTab,
            config,
        });
    }, [data, activeTab, config]);

    return { data: result, isLoading };
};

export default useTabFilteredData;
